<template>
    <div >

        <div class="topMenu" style="background-color: #222; border-color: #080808; ">
            <div class="container" style="margin: auto;display: flex; height: 50px; line-height: 50px;">
                <div style="display: flex; flex: 1; color: #fff;" class="topmenuitemlist">
                    <!-- <div class="topmenuitem" @click="toeventlist">D Avenue Tech</div>
                    <div class="topmenuitem" @click="toeventlist">Home</div>
                    <div class="topmenuitem" @click="togeneral">General</div>
                    <div class="topmenuitem" @click="tofieldlist">Fields</div> -->
                    <div class="topmenuitem" @click="toBadge">意见建议管理</div>
                    <div class="topmenuitem" @click="tocatelist">门店管理</div>
                    <!-- <div class="topmenuitem" @click="toemailtemp">Email Temp</div> -->
                    <!-- <div class="topmenuitem" @click="toCheckIn">CheckIn</div> -->
                    <div class="topmenuitem" @click="toPromoCode">类别管理</div>
                    <div class="topmenuitem" v-if="showUserManage" @click="tovisitorlist">用户管理</div>
                </div>
                <div>
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link">
                            {{ nickname }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
        <div style="height: 50px;"></div>



        <!-- content -->


        <!-- content -->

    </div>
</template>

<script>

import axios from 'axios'

export default {
    name: 'topmenu',
    data: function () {
        return {
            currentPage: 1,
            nickname: '',
            loading: false,
            searchTxt: "",
            list: [],
            total: 0,
            showUserManage:false
        }
    },
    components: {

    },
    methods: {
        toCheckIn(){
            this.$router.push("/checkin");
        },
        toPromoCode(){
            this.$router.push("/PromoCodelist");
        },
        togeneral(){
            this.$router.push("/general");
        },
        tovisitorlist(){
            this.$router.push("/visitorlist");
        },
        tocatelist(){
            this.$router.push("/catelist");
        },
        tofieldlist(){
            this.$router.push("/fieldlist");
        },
        toeventlist(){
            this.$router.push("/eventlist");
        },
        toemailtemp(){
            this.$router.push("/emailtemplist");
        },
        toBadge(){
            this.$router.push("/badgelist");
        },
        toEdit(id) {
            this.$router.push("/addevent?id=" + id);
        },

        handleCommand(command) {
            if (command == 'logout') {
                localStorage.removeItem('userJson');
                this.$router.replace('/login');
            }
        },

        toAdd() {
            this.$router.push('/addevent');
        }
    },
    mounted() {
        var userJson = JSON.parse(localStorage.getItem("userJson"));
        console.log(userJson);
        var nickname = userJson['nickname'];
        this.nickname = nickname;
        this.permissions = userJson['permissions'];
        var showUserManage= this.showUserManage;
        for(var i =0;i<this.permissions.length;i++){
            var permission = this.permissions[i]['code'];
            if(permission == "UserManage"){
                showUserManage=true;
            }
        }
        this.showUserManage=showUserManage;
    },
    beforeDestroy() {

    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/home/components/topmenu.vue